import { updatePassword } from "../lib/auth.js";
import { escapeHtml } from "../lib/ui.js";

/**
 * Pantalla a la que se llega desde el link del correo de recuperación.
 * Para cuando se muestra, supabase-js ya canjeó el token del hash por una
 * sesión temporal, así que updateUser() puede fijar la contraseña nueva.
 */
export function renderResetPassword(container, onDone) {
  container.innerHTML = `
    <div class="login-screen">
      <form class="login-card" id="reset-form">
        <h1>Grow Up</h1>
        <p class="subtitle">Elegí tu contraseña nueva</p>
        <div class="field">
          <label for="p1">Contraseña nueva</label>
          <input type="password" id="p1" name="password" required minlength="6" autocomplete="new-password" />
          <p class="field-hint">Mínimo 6 caracteres.</p>
        </div>
        <div class="field">
          <label for="p2">Repetila</label>
          <input type="password" id="p2" name="confirm" required minlength="6" autocomplete="new-password" />
        </div>
        <button type="submit" class="btn block" id="reset-submit">Guardar contraseña</button>
        <p class="error-text" id="reset-error" hidden></p>
      </form>
    </div>
  `;

  const form = container.querySelector("#reset-form");
  const errorEl = container.querySelector("#reset-error");
  const submit = container.querySelector("#reset-submit");

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    errorEl.hidden = true;

    if (form.password.value !== form.confirm.value) {
      errorEl.textContent = "Las dos contraseñas no coinciden.";
      errorEl.hidden = false;
      return;
    }

    submit.disabled = true;
    submit.textContent = "Guardando…";

    try {
      await updatePassword(form.password.value);
      // Limpia el token del hash para que un F5 no reabra esta pantalla.
      window.history.replaceState(null, "", window.location.pathname);
      window.alert("Contraseña actualizada. Ya podés usarla para entrar.");
      onDone();
    } catch (error) {
      errorEl.textContent = escapeHtml(error.message);
      errorEl.hidden = false;
      submit.disabled = false;
      submit.textContent = "Guardar contraseña";
    }
  });
}
